<template>
    <Modal
        v-bind="$attrs"
        v-on="$listeners"
        :value="value"
        class-name="modal-container"
        :width="width"
        @input="onInput"
    >
        <p slot="header" class="header-class">
            <Icon type="ios-checkmark-circle" color="#45B343" size="24" />
            <span class="title">恭喜，录入成功！</span>
        </p>
        <div style="text-align:center" class="body-class">
            <p class="text">{{ text }}</p>
        </div>
        <div slot="footer" style="text-align:center;padding: 15px 0px;">
            <Button
                class="btn"
                :loading="modal_loading"
                @click="cancel"
                :style="{ background: btnColor }"
                >{{ btnCancel }}</Button
            >
            <Button
                class="btn btn-confirm"
                :loading="modal_loading"
                @click="comfirm"
                :style="{ background: btnColor }"
                >{{ btnConfirm }}</Button
            >
        </div>
    </Modal>
</template>

<script>
export default {
    name: "ContractCreateSuccess",
    data() {
        return {
            modal_loading: false,
        };
    },
    props: {
        // 提示的内容
        text: {
            type: String,
            default:
                "可将生成的二维码发送给租客，关注公众号后立即绑定微信账号，【租客管理】仍可获取二维码",
        },
        // 确认按钮文字
        btnConfirm: {
            type: String,
            default: "返回房源管理",
        },
        // 取消按钮文字
        btnCancel: {
            type: String,
            default: "再录一个",
        },
        // 确认按钮颜色
        btnColor: {
            type: String,
            default: "",
        },
        // 值
        id: {
            type: String,
            default: "",
        },
        value: {
            type: Boolean,
            default: false,
        },
        width: {
            type: String,
            default: "420px",
        },
    },
    methods: {
        onInput(val) {
            this.$emit("input", val);
        },
        // 取消
        cancel() {
            this.$emit("cancelModal", this.id);
        },
        // 确定
        comfirm() {
            this.$emit("confirmModal", this.id);
        },
    },
};
</script>

<style lang="less" scoped>
.header-class {
    text-align: center;
    font-size: 18px;
    border: none;
    height: 60px;
    line-height: 90px;
    .title {
        margin-left: 10px;
        font-size: 18px;
        font-weight: 400;
        color: rgb(170, 170, 170);
    }
}
.body-class {
    .text {
        font-size: 14px;
        font-weight: 400;
        text-align: left;
        color: rgb(51, 51, 51);
        text-align: center;
    }
}
.btn {
    width: 135px;
    height: 32px;
    &-confirm {
        background-color: @primary-color;
        color: #ffffff;
    }
}
</style>
<style lang="less">
// 居中
.modal-container {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 240px;
    .ivu-modal {
        top: 0;
    }
    // 去除边框
    .ivu-modal-header,
    .ivu-modal-footer {
        border: none !important;
    }
}
</style>
